import React, { useEffect, useState } from "react";
import api from "@/api";
import { PageTitle, EmptyState, Badge } from "@/components/ui-kit";
import InspireBanner from "@/components/InspireBanner";
import { downloadFile } from "@/lib/download";
import { ShieldCheck, FileDown } from "lucide-react";
import { toast } from "sonner";

export default function Pledges() {
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/pledges").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const fmt = (d) => { if (!d) return "-"; try { return new Date(d).toLocaleString("ar"); } catch { return d; } };
  const accepted = items.filter((c) => c.pledge_accepted).length;
  const doExport = async () => { try { await downloadFile("/pledges/export", "pledges.xlsx"); } catch { toast.error("تعذر التصدير"); } };

  return (
    <div>
      <InspireBanner />

      <PageTitle title="سجل التعهّدات" subtitle="المنسقون الذين وثّقوا تعهّد صدق البيانات وتاريخه" icon={ShieldCheck}
        actions={<button data-testid="export-pledges-btn" onClick={doExport} className="glass glass-hover px-3 py-2 rounded-xl flex items-center gap-2 text-stone-800 text-sm"><FileDown size={17} /> تصدير Excel</button>}
      />

      {items.length > 0 && (
        <div className="glass rounded-2xl p-4 mb-4 flex items-center gap-3" data-testid="pledges-summary">
          <ShieldCheck className="text-emerald-600" size={22} />
          <span className="text-sm text-stone-700">وثّق التعهّد <strong className="text-emerald-700">{accepted}</strong> من أصل <strong>{items.length}</strong> منسق.</span>
        </div>
      )}

      {!items.length ? <EmptyState text="لا يوجد منسقون بعد" icon={ShieldCheck} /> : (
        <div className="glass rounded-2xl p-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-stone-500 text-right border-b border-amber-400/15">
              <th className="py-3 px-2 font-medium">المنسق</th>
              <th className="py-3 px-2 font-medium">المدرسة</th>
              <th className="py-3 px-2 font-medium">البريد</th>
              <th className="py-3 px-2 font-medium">الجوال</th>
              <th className="py-3 px-2 font-medium">حالة التعهّد</th>
              <th className="py-3 px-2 font-medium">تاريخ التوثيق</th>
            </tr></thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} data-testid={`pledge-row-${c.id}`} className="border-b border-amber-400/10 hover:bg-amber-100/50 transition">
                  <td className="py-3 px-2 text-stone-800 font-medium">{c.name}</td>
                  <td className="py-3 px-2 text-stone-600">{c.school_name || "-"}</td>
                  <td className="py-3 px-2 text-stone-600">{c.email}</td>
                  <td className="py-3 px-2 text-stone-600">{c.phone || "-"}</td>
                  <td className="py-3 px-2">{c.pledge_accepted
                    ? <Badge className="bg-emerald-500/15 text-emerald-700 border-emerald-400/30">موثّق</Badge>
                    : <Badge className="bg-amber-500/15 text-amber-700 border-amber-400/30">بانتظار التوثيق</Badge>}</td>
                  <td className="py-3 px-2 text-stone-600">{c.pledge_accepted ? fmt(c.pledge_accepted_at) : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
